"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('webcam', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("g", {
    transform: "translate(2.000000, 4.000000)",
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("path", {
    d: "M5.825071,25.765534 C9.46166403,30.75644 15.352045,34 22,34 C28.647955,34 34.538336,30.75644 38.174929,25.765534 C41.7910586,29.5076746 44,34.5076 44,40 L0,40 C0,34.5076 2.20894143,29.5076746 5.825071,25.765534 Z",
    stroke: props.outStrokeColor,
    fill: props.outFillColor
  }), _react.default.createElement("circle", {
    stroke: props.outStrokeColor,
    fill: props.outFillColor,
    cx: "22",
    cy: "13",
    r: "13"
  }), _react.default.createElement("circle", {
    stroke: props.innerStrokeColor,
    fill: props.innerFillColor,
    cx: "22",
    cy: "13",
    r: "5"
  })))));
});

exports.default = _default;